export class UserDailyGoal {
  userId: number;
  expireTime: number;
  isCompleted: boolean;
  totalCall: number;
}
